import {inject, Injectable} from "@angular/core";
import {CampaignApiService} from "./campaign.api.service";
import {ECampaign} from "../../core/business-logic/campaign/entity/e.campaign";
import {map} from "rxjs";

@Injectable({
  providedIn: 'root'
})
export class CampaignRepository {
  public readonly campaignApiService = inject(CampaignApiService);

  public findOneBySlug(slug: string) {
    return this.campaignApiService.documentBySlug(slug).pipe(
      map((campaign) => new ECampaign(campaign.data)),
    );
  }

  public findOneById(id: string) {
    return this.campaignApiService.document(id).pipe(
      map((campaign) => new ECampaign(campaign.data)),
    );
  }

  public findAll() {
    return this.campaignApiService.documents().pipe(
      map(({data}) => data.map((campaign) => new ECampaign(campaign))),
    );
  }
}
